module.exports = __webpack_public_path__ + "img/ChangeTenant.b2d9edc6.png";